(function () {
  deleteItem.$inject = ["PATH"];
  app.directive('disableItem', deleteItem);

  function deleteItem(PATH) {
    return {
      restrict: 'E',
      templateUrl: PATH.components + 'disableItemDirective/disableItemDirective.html',
      replace: true,
      scope: {
        childrenStyle: '=',
        disableAction: '&',
        caption: '=?',
        message: '=?'
      },
      controller: 'DisableItemController'
    };
  }
})();



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/disableItemDirective/disableItemDirective.js